import dayjs from 'dayjs';
import * as yup from 'yup';

import { VALIDATORS } from '@/common';
import { DEFAULT_DATE_FORMAT, REQUIRED_TEXT } from '@/common/constants';

import { ACTIVE_STATUS_KEY, CANCELLED_STATUS_KEY, LimitedUses } from '../enrollmentModal.types';

export const MIN_PER_PAY_AMOUNT = 1;
const DATE_SHOULD_BE_WITHIN_PLAN_YEAR_MESSAGE = 'This date must be within plan year';

export const DEDUCTIBLE_DATE_VALIDATOR = yup
  .string()
  .test({
    test(val) {
      const isDeductibleMetTrue = this.parent.limitedUse === LimitedUses.GENERALE_PURPOSE_DEDUCTIBLE_MET;
      const startDate = dayjs(this.parent?.planStartDate);
      const endDate = dayjs(this.parent?.planEndDate);

      const deductibleMetDate = dayjs(val);
      if (isDeductibleMetTrue && this.parent?.planStartDate && val) {
        return this.parent?.planEndDate
          ? deductibleMetDate >= startDate && deductibleMetDate <= endDate
          : deductibleMetDate >= startDate;
      }
      return true;
    },
    message: DATE_SHOULD_BE_WITHIN_PLAN_YEAR_MESSAGE,
  })
  .test({
    test(val) {
      const isDeductibleMetTrue = this.parent.limitedUse === LimitedUses.GENERALE_PURPOSE_DEDUCTIBLE_MET;
      if (isDeductibleMetTrue && !val) {
        return false;
      }
      return true;
    },
    message: REQUIRED_TEXT,
  });

export const CHANGE_DATE_VALIDATOR = (params: {
  lastCoverageEndDate?: string | null;
  planStartDate?: string;
  planEndDate?: string;
  currentEnrollmentStatus?: string;
}) =>
  VALIDATORS.DATE_FORMAT.test({
    test(val) {
      const enrollmentStatus = this.parent?.enrollmentStatus;
      const startDate = params?.planStartDate;
      const endDate = params?.planEndDate;
      const coverageDateEnd = params?.lastCoverageEndDate
        ? dayjs(params.lastCoverageEndDate).add(1, 'day')
        : undefined;

      const getMessage = () =>
        params?.lastCoverageEndDate && enrollmentStatus === CANCELLED_STATUS_KEY
          ? `Date must be in range from ${startDate} to ${dayjs(params.lastCoverageEndDate)
              .add(1, 'day')
              .format(DEFAULT_DATE_FORMAT)}`
          : endDate
          ? `Date must be in range from ${startDate} to ${endDate}`
          : `Date must not be earlier than ${startDate}`;
      if (enrollmentStatus === ACTIVE_STATUS_KEY) {
        if (this.parent?.planStartDate && val && dayjs(val) < dayjs(this.parent?.planStartDate)) {
          return this.createError({ message: getMessage() });
        }
        if (this.parent?.planEndDate && val && dayjs(val) > dayjs(this.parent?.planEndDate)) {
          return this.createError({ message: getMessage() });
        }
      }
      if (enrollmentStatus === CANCELLED_STATUS_KEY) {
        if (this.parent?.planStartDate && val && dayjs(val) < dayjs(this.parent?.planStartDate)) {
          return this.createError({ message: getMessage() });
        }
        if (coverageDateEnd && val && dayjs(val) > coverageDateEnd) {
          return this.createError({ message: getMessage() });
        }
      }
      return true;
    },
    message: REQUIRED_TEXT,
  }).required(REQUIRED_TEXT);

export const HEALTH_PLAN_CHANGE_DATE_VALIDATOR = (params: {
  healthPlanStartDate?: string;
  healthPlanEndDate?: string;
}) =>
  VALIDATORS.DATE_FORMAT.test({
    test(val) {
      const enrollmentStatus = this.parent?.healthPlanEnrollmentStatus;
      const startDate = params?.healthPlanStartDate;
      const endDate = params?.healthPlanEndDate;

      const getMessage = () =>
        endDate
          ? `Date must be in range from ${startDate} to ${endDate}`
          : `Date must not be earlier than ${startDate}`;

      if (enrollmentStatus === ACTIVE_STATUS_KEY || enrollmentStatus === CANCELLED_STATUS_KEY) {
        if (this.parent?.healthPlanStartDate && val && dayjs(val) < dayjs(this.parent?.healthPlanStartDate)) {
          return this.createError({ message: getMessage() });
        }
        if (this.parent?.healthPlanEndDate && val && dayjs(val) > dayjs(this.parent?.healthPlanEndDate)) {
          return this.createError({ message: getMessage() });
        }
      }
      return true;
    },
    message: REQUIRED_TEXT,
  }).required(REQUIRED_TEXT);
